// extracted by mini-css-extract-plugin
module.exports = {"title-container":"reference-error-table_title-container__TRRir","section-title":"reference-error-table_section-title__HQhJy"};